import React from 'react';
import { Download, Printer, PlayCircle } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-[#1E3A5F] text-white relative overflow-hidden" data-id="element-331">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-332"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl text-center" data-id="element-333">
        <div className="inline-block bg-[#F59E0B] text-[#1E3A5F] font-black tracking-widest uppercase px-6 py-2 rounded-full mb-8 text-sm md:text-base" data-id="element-334">
          LA SOLUCIÓN
        </div>

        <h2 className="text-4xl md:text-6xl font-extrabold mb-8 text-white drop-shadow-md" data-id="element-335">
          MEGA PACK APRENDIZAJE LECTURA™
        </h2>

        <p className="text-xl md:text-2xl text-blue-100 mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-336">
          Un sistema completo pensado para maestras de primaria argentina que
          quieren dar clases con orden, tranquilidad y sin sacrificar su tiempo
          personal.
        </p>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 md:p-12 rounded-3xl mb-12" data-id="element-337">
          <p className="text-2xl md:text-3xl font-bold text-white mb-10" data-id="element-338">
            Todo el material ya está escrito, organizado y listo.
          </p>

          <p className="text-xl text-amber-200 font-medium mb-8 uppercase tracking-wide" data-id="element-339">
            Solo tenés que:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-340">
            <div className="flex flex-col items-center" data-id="element-341">
              <div className="w-20 h-20 bg-[#16A34A] rounded-2xl flex items-center justify-center mb-6 shadow-lg" data-id="element-342">
                <Download className="w-10 h-10 text-white" data-id="element-343" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-344">Descargar.</h3>
            </div>

            <div className="flex flex-col items-center" data-id="element-345">
              <div className="w-20 h-20 bg-[#F59E0B] rounded-2xl flex items-center justify-center mb-6 shadow-lg" data-id="element-346">
                <Printer className="w-10 h-10 text-white" data-id="element-347" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-348">Imprimir.</h3>
            </div>

            <div className="flex flex-col items-center" data-id="element-349">
              <div className="w-20 h-20 bg-blue-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg" data-id="element-350">
                <PlayCircle className="w-10 h-10 text-white" data-id="element-351" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-352">Usar.</h3>
            </div>
          </div>
        </div>
      </div>
    </section>;
}